/**
 * Teto de linhas que a API devolve num ranking.
 *
 * ⚠️ Espelha `RANKING_MAX_ROWS` de
 * `apps/api/src/modules/dashboards/transport-dashboards.service.ts`. Se um mudar
 * sem o outro, o rodapé para de reconhecer a lista truncada e passa a afirmar um
 * total que ninguém apurou ("de 100 clientes" numa base de 400).
 *
 * A duplicação é deliberada: `@bi/types` não tem build — `main` aponta para
 * `src/index.ts` e o pacote só funciona porque todo import de lá é `import type`,
 * apagado na compilação. Exportar um valor de runtime dali derruba a API em
 * produção (Node 20 não carrega `.ts`).
 */
export const RANKING_MAX_ROWS = 100;
